
jQuery.widget("bluaul.Ticket", jQuery.common.vcBaseV4, {
    /// <summary>
    /// This object provides js functions for the Widget.Ticket.Ticket.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 1.12.2024<br />
    /// Copyright ©: EUDT GmbH 2025 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 6.2.2025- AFU                                          *<br />
    /// **********************************************************************<br />
    /// * - extracted from Operation.js                                      *<br />
    /// **********************************************************************<br />
    /// </summary>
    divLoading: null,
    divEntry: null,
    entryList: [],
    assignmentType: -1,
    entry: null,
    editLevel: 0, //level 0 = nothing, level 1: all (owner), level 2:executor, level 3:validator
    ddlUnit: null,
    ddlHW: null,
    initState: true,
    dirty: false,
    divEntry: null,
    descriptionText: "",
    owner: -1,
    signalFilter: null,
    sendEmailType: 0, //0 - no email seinding, 1 - send internal email only, 2 - send email to all
    projectContacts: null,
    assignmentsEditable: true,
   
    _create: function () {
        this._createVisual(369);//369
        this._super();
    },
    _initHTML: function () {
        var me = this;
        try {
           
            me._setRoot(".ticket");
            //due to migration from widget V2 to V4 we have to fix this with a hack
            //the divEntry is needed as first object level - otherwise all existing css would be wrong

            me.divLoading = me._setObj("div-loading", "").html(me.getLoadingIcon());
            me.divEntry = me._setObj("div-entry", "");
            me.myRoot.append(me.divLoading, me.divEntry);

            if (me.specific.print) {
                me.divEntry.addClass("print");
                me.myRoot.css("height", "auto");
            }
          
            objTicketSettings._buildHtml(me);

            //simplify the view if the user has restricted rights
            if (me.specific.simpleEditMode) {
                objTicketSettings._simplify(me);
            }

            me._setHeightsAndWidths();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _initEvents: function () {
        var me = this;
        try {
            //init data objects
            me.myData = { editor: "", entryList: null };

            me.divLoading.show();
            me.divEntry.hide();

            //top menu
            me.myHtml.topMenu.btnBack.off("click").on("click", function () { me._askDismissChanges() }).button();

            me.myHtml.topMenu.btnPrint.off("click").on("click", function () { me._openPrint(); });
            me.myHtml.topMenu.btnDelete.off("click").on("click", function () { me._askBeforeDelete(); });


            // Save only (no email, no close) - ONLY for existing tickets possible
            me.myHtml.topMenu.btnSave.off("click").on("click", function () {
                if (!me.entry || !me.entry.Id || me.entry.Id <= 0) return false;
                me.sendEmailType = 0;
                me._save(false);
            }).button();

            // hide initiall
            me.myHtml.topMenu.btnSave.hide();

            // Save & Close
            me.myHtml.topMenu.btnSaveClose.off("click").on("click", function () {  me._askForEmailSendingBeforeSave();  }).button();


            //clickhandler for sub buttons
            me.myHtml.topMenu.wrapper.find(".div-sub-menu").off("click").on("click", function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                var btn = $(this);
                var targetType = parseInt(btn.data("type"), 10) || 0;

                me._navigateTo(targetType, btn);
            }).button();

            if (!me.specific.readOnlyMode) {
                me._addSublistClickHandler("#div-watchlist");
                me._addSublistClickHandler("#div-ext-watchlist");
                me._addSublistClickHandler("#div-signals");
            } else {
                me.myHtml.topMenu.wrapper.show();
            }


            if (me.specific.print) {
                // if activities only print version, all other sections shall be hidden
                if (me.specific.activitiesOnly) {
                    me.myHtml.rowPrintInfo.boxPrintInfo.show();
                    me.myHtml.topMenu.orderNo.show(); // "<i class='fa " + me.entry.Infos.TypeIcon + "'></i> " + me.entry.Infos.Type + "-" + me.entry.Id);

                    me.divEntry.addClass("activities-only");
                    me.myHtml.topMenu.id.hide();
                    me.myHtml.header.wrapper.show();
                    me.myHtml.topMenu.wrapper.height(35);
                    me.myHtml.rowUser.wrapper.hide();
                    me.myHtml.rowMain.wrapper.hide();
                    me.myHtml.rowEmailHistory.wrapper.hide();
                    me.myHtml.rowActivities.wrapper.show();

                    me.myHtml.rowWatchlist.wrapper.hide();
                    me.myHtml.rowExtWatchlist.wrapper.hide();
                    me.myHtml.footer.wrapper.hide();
                    
                    if (me.specific.accounting) {
                        me.myHtml.rowAccounting.wrapper.hide();
                    }
                }
                else {
                    me.divEntry.removeClass("activities-only");
                    me.myHtml.header.wrapper.show();
                    me.myHtml.topMenu.wrapper.height(35);
                    me.myHtml.rowUser.wrapper.show();
                    me.myHtml.rowMain.wrapper.show();
                    me.myHtml.rowEmailHistory.wrapper.hide();
                    me.myHtml.rowActivities.wrapper.show();                    

                    me.myHtml.rowWatchlist.wrapper.show();
                    me.myHtml.rowExtWatchlist.wrapper.show();
                    me.myHtml.footer.wrapper.show();
                    if (me.specific.accounting) { // TODO: there was actually a bug, that accounting was always false!!!
                        me.myHtml.rowAccounting.wrapper.hide();
                    }

                }

                //if we want to change the current language we reload the page with a new querystring parameter
                me.myHtml.header.ddlLang.off("change").on("change", function () {
                    var url = window.location + "&setlang=" + $(this).val();
                    window.open(url, '_self');
                });
            }

            //clickhandler for assignment menu buttons
            me.fnd("#div-entry #div-assignments #div-edit .button-toggle").off("click").on("click", function () {
                me.assignmentType = parseInt(($(this).data("type")));
                //switch active button
                objTicketAssignments._toggleAssignmentEditButtons(me, me.assignmentType);
                //rebuild assignments
                objTicketAssignments._showAssignments(me, true);
                me.dirty = true;
                $(this).removeClass("dirty").addClass("dirty");
                me._validate();
            }).button();

            //init dropdowns
            me.ddlScope = me._initSelectize(me.myHtml.rowMain.infoBox.ddlScope, JSON.parse(me.specific.ddlScopes), true);
            me.ddlTasks = me._initSelectize(me.myHtml.rowMain.infoBox.ddlTasks, JSON.parse(me.specific.ddlTasks), true);
            me.ddlPriorities = me._initSelectize(me.myHtml.rowMain.infoBox.ddlPriority, JSON.parse(me.specific.ddlPriorities), true);
            me.ddlStates = me._initSelectize(me.myHtml.rowMain.infoBox.ddlState, JSON.parse(me.specific.ddlStates), true );

            // state dropdown needs a special class for custom css - no scrollbar shall be shown
            if (me.ddlStates && me.ddlStates.$dropdown) { me.ddlStates.$dropdown.addClass("ticket-ddl-state-dropdown"); }

            me.ddlOwner = me._initSelectize(me.myHtml.rowUser.userBox.ddlOwner, JSON.parse(me.specific.ddlUsers), true);
            me.ddlExecutor = me._initSelectize(me.myHtml.rowUser.userBox.ddlExecutor, JSON.parse(me.specific.ddlUsers), true);
            me.ddlValidator = me._initSelectize(me.myHtml.rowUser.userBox.ddlValidator, JSON.parse(me.specific.ddlUsers), true);
            me.ddlAccounter = me._initSelectize(me.myHtml.rowAccounting.ddlAccounter, JSON.parse(me.specific.ddlUsers), true);


            me.ddlLogger = me._initSelectize(me.myHtml.rowMain.assignmentBox.ddlLogger, JSON.parse(me.specific.loggers));
            me.ddlLogger.on("change", function () {
                objTicketAssignments._changeAssignmentProject(me);
                me._setDirty(me.myHtml.rowMain.assignmentBox.ddlLogger);
            });
            me.ddlOrderType = me._initSelectize(me.myHtml.rowAccounting.ddlOrderType, JSON.parse(me.specific.ddlOrderTypes), true);

            //init specific event handler for input validation
            me.divEntry.off("change", "#txt-name").on("change", "#txt-name", function () { if (!$(this).attr("readonly")) { me._setDirty($(this)) } });
            me.divEntry.off("keyup", "#txt-name").on("keyup", "#txt-name", function () { if (!$(this).attr("readonly")) { me._setDirty($(this)) } });
            me.divEntry.off("change", "#txt-order").on("change", "#txt-order", function () { if (!$(this).attr("readonly")) { me._setDirty($(this)) } });
            me.divEntry.off("keyup", "#txt-order").on("keyup", "#txt-order", function () { if (!$(this).attr("readonly")) { me._setDirty($(this)) } });

            me.myHtml.rowAccounting.chkActivities.off("click").on("click", function () { if (!$(this).attr("readonly")) { me._setDirty($(this)) } });
            me.myHtml.rowAccounting.chkDeliveryNote.off("click").on("click", function () { if (!$(this).attr("readonly")) { me._setDirty($(this)) } });
            me.myHtml.rowAccounting.chkWorkReport.off("click").on("click", function () { if (!$(this).attr("readonly")) { me._setDirty($(this)) } });


            me.fnd(".clear-date").off("click").on("click", function () { objTicketDatePicker._removeDatePicker(me, $(this)); });

            me.fnd(".has-tip").tipTip({ defaultPosition: 'top' });


            //init click handler for info icon in signal list
            me.divEntry.off("click", "#div-signals .fa-info-circle").on("click", "#div-signals .fa-info-circle", function (e) { me.vcV.showSignalAnalogSummaryDialog($(this).data("id")); e.stopPropagation() });


            //fetch entry
            me._fetch(me.specific.ticketId);


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _navigateTo: function (type, btn) {
        var me = this;
        me.myHtml.topMenu.wrapper.find(".div-sub-menu").removeClass("button-toggle-active");
        btn.addClass("button-toggle-active");

        me.myHtml.rowUser.wrapper.hide();
        me.myHtml.rowMain.wrapper.hide();
        me.myHtml.rowAccounting.wrapper.hide();
        me.myHtml.rowActivities.wrapper.hide();
        me.myHtml.rowWatchlist.wrapper.hide();
        me.myHtml.rowExtWatchlist.wrapper.hide();
        me.myHtml.rowEmailHistory.wrapper.hide();
        me.myHtml.rowProjectInfo.wrapper.hide();
        me.myHtml.footer.wrapper.show();

        switch (type) {
            case 1:  // main
                me.myHtml.rowUser.wrapper.show();
                me.myHtml.rowMain.wrapper.show();
                break;
            case 2:  // accounting
                me.myHtml.rowAccounting.wrapper.show();
                break;
            case 3:  // activities
                me.myHtml.rowActivities.wrapper.show();
                objTicketActivities._loadActivityForm(me);
                break;
            case 4:  // watchlist
                me.myHtml.rowWatchlist.wrapper.show();
                break;
            case 5:  // ext watchlist
                me.myHtml.rowExtWatchlist.wrapper.show();
                break;
            case 6:  // email history
                me.myHtml.rowEmailHistory.wrapper.show();
                objTicketEmailHistory._fetchEmailHistory(me);
                break;
            case 7: // project info
                me.myHtml.rowProjectInfo.wrapper.show();
                me._fetchProjectInfo();
                break;
        }
    },




    _addSublistClickHandler: function (id) {
        /// <summary>
        ///  This function adds the clickhandlers to a sublist
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
            //clickhandler for watchlist checkbox
            me.fnd(id, "input").off("click", "input").on("click", "input", function () { me._setDirty(me.visual.find(id)); });
            //clickhandler for watchlist name
            me.fnd(id).off("click", ".vc-list-item span").on("click", ".vc-list-item span", function (e) {
                var chb = $(e.currentTarget).parents(".vc-list-item").find("input");
                chb.prop("checked", !chb.prop("checked"));
                me._setDirty(me.visual.find(id));
            });
            return true;
        } catch (e) { me._writeErr(e); return false }

    },
    _fetch: function (ticketId) {
        /// <summary>
        ///  This function fetches the entry data
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            me.getData({ "typeid": 1, 'TicketID': ticketId, fs: {} }, function (result) {
                if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
                if (result.length > 0) {
                    if (result[0].Data.State == 7) //if ticket is not billable, hide accounting tab
                        me.myHtml.topMenu.btnAccounting.hide();
                }

                me.myData.entryList = result;
                me._setReadOnlyForBilledTickets();
                me._showEntry(ticketId);
                me._validate();
                return true;
            });
            return true;
        } catch (e) { me._writeErr(e); return false }

    },

    _setReadOnlyForBilledTickets: function () {
        /// <summary>
        ///  sets the read only mode if the ticket already has accounting time / is billed
        /// </summary>
        var me = this;
        try {
            if (!me.myData.entryList || !me.myData.entryList.length) { return false; }

            if (me.specific.readOnlyMode) return true; // if already in read only mode, we do not need to check the billing state

            var entry = me.myData.entryList[0];
            var hasAccountingTime = entry.Data.AccountingTime != "" ? true : false;

            if (hasAccountingTime) {
                me.specific.readOnlyMode = true;

                if (me.myHtml && me.myHtml.topMenu) {
                    if (me.myHtml.topMenu.btnDelete) {
                        me.myHtml.topMenu.btnDelete.hide();
                    }
                    if (me.myHtml.topMenu.btnSave && typeof me.myHtml.topMenu.btnSave.button === "function") {
                        me.myHtml.topMenu.btnSave.button("disable").hide();
                    }
                    if (me.myHtml.topMenu.btnSaveClose && typeof me.myHtml.topMenu.btnSaveClose.button === "function") {
                        me.myHtml.topMenu.btnSaveClose.button("disable");
                    }

                }
            }

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },



    _showEntry: function (id) {
        /// <summary>
        ///  This function builds up the complete entry
        /// </summary>
        var me = this;
        var id;
        var i;
        var bAdd;
        try {
            if (me.error) return false;
            //we reset the loading state

            me.initState = true;
            me.entry = null;
            //clear all items
            me._clearForm();


            //if we got a new entry
            if (id === -1) {
                bAdd = true;
                //get default settings for a ticket entry

                //default entry template for new tickets
                var tpl = me.specific.tplTicket;

                //optional specific start values  
                var startEntry = me.specific.startEntry;

                if (startEntry !== null) {
                    startEntry.Blid = startEntry.Blid == -1 ? tpl.Blid : startEntry.Blid;
                    startEntry.TypeID = startEntry.TypeID == -1 ? tpl.TypeID : startEntry.TypeID;
                    startEntry.Uid = startEntry.Uid == -1 ? tpl.Uid : startEntry.Uid;
                    startEntry.Data.Priority = startEntry.Data.Priority == -1 ? tpl.Data.Priority : startEntry.Data.Priority;
                    startEntry.Data.Scope = startEntry.Data.Scope == -1 ? tpl.Data.Scope : startEntry.Data.Scope;
                    startEntry.Data.State = startEntry.Data.State == -1 ? tpl.Data.State : startEntry.Data.State;
                    startEntry.Data.TaskID = startEntry.Data.TaskID == -1 ? tpl.Data.TaskID : startEntry.Data.TaskID;

                    startEntry.Users = startEntry.Users.Users.length == 0 ? tpl.Users : startEntry.Users;

                    startEntry.Data.StartDate = startEntry.Data.StartDate != "" ? startEntry.Data.StartDate : moment().toDate().format("dd.MM.yyyy");

                    startEntry.Data.OrderTypeID = startEntry.Data.OrderTypeID == -1 ? tpl.Data.OrderTypeID : startEntry.Data.OrderTypeID;

                    me.entry = startEntry;
                } else {
                    me.entry = tpl;
                }

            } else {
                bAdd = false;
                me.entry = me.myData.entryList[0];
            }
            //stop if something went wrong
            if (me.entry === null) { me.showMessage(me.resources.noEntriesExist, true); return false; }

            // check if we have a permanent ticket, because then billing process is different
            me.isPermanentTicket = false;
            if (me.entry && me.entry.Data && typeof me.entry.Data.State !== "undefined" && typeof me.specific.STATE_PERMANENT_TYPEID !== "undefined") {
                me.isPermanentTicket = (me.entry.Data.State === me.specific.STATE_PERMANENT_TYPEID);
            }


            if (bAdd) {
                me.myHtml.footer.wrapper.hide();
                me.myHtml.topMenu.id.hide();
                me.myHtml.topMenu.btnPrint.hide();
                me.myHtml.topMenu.btnDelete.hide();
                objTicketUser._fetchContacts(me, me.entry.Blid);

                // new ticket: only save & close, no save-only
                me.myHtml.topMenu.btnSave.hide();
                me.myHtml.topMenu.btnSaveClose.show();

            } else {

                // show everything again! if saved is clicked during adding (not save and close), we were first in bAdd mode and everything was hidden - therefore, we need to show it again
                me.myHtml.footer.wrapper.show();
                me.myHtml.topMenu.id.show();
                me.myHtml.topMenu.btnPrint.show();


                // existing ticket: allow save-only (if not readonly)
                if (!me.specific.readOnlyMode && me.entry && me.entry.Id > 0) me.myHtml.topMenu.btnSave.show();
                else me.myHtml.topMenu.btnSave.hide();

                me.myHtml.topMenu.btnSaveClose.show();


                if (me.specific.hasRootMembership)
                    me.myHtml.topMenu.btnDelete.show();
                else
                    me.myHtml.topMenu.btnDelete.hide();

                me.myHtml.topMenu.id.html("<i class='fa " + me.entry.Infos.TypeIcon + "'></i> " + me.entry.Infos.Type + "-" + me.entry.Id);
                
                me.myHtml.footer.lastEdited.html(me.entry.Data.LastEdited + ", " + me.entry.Infos.Creator);

                me.myHtml.rowPrintInfo.txtProject.html(me.entry.Assignments.Project);
                me.myHtml.rowPrintInfo.txtTicketId.html(me.entry.Infos.Type + "-" + me.entry.Id); 


                me.myHtml.rowPrintInfo.txtBillingContact.html("&nbsp;");



                me.myHtml.rowPrintInfo.txtTicketName.html(me.entry.Data.Name);

                me.myHtml.topMenu.orderNo.html("<i class='fa-regular fa-note'></i> " + me.specific.resources.orderNumber + ": ");
                

            }
         
            //fill entries
            //fill info box
            me.myHtml.rowMain.infoBox.txtName.val(me.entry.Data.Name);

            me.myHtml.rowMain.infoBox.txtTasks.html($("<i>").addClass(me.entry.Infos.TaskIcon)).append(" " + me.entry.Infos.Task);
            me.ddlTasks.setValue(me.entry.Data.TaskID, true);

            me.myHtml.rowMain.infoBox.txtPriority.html($("<i>").addClass(me.entry.Infos.PriorityIcon)).append(" " + me.entry.Infos.Priority);
            me.ddlPriorities.setValue(me.entry.Data.Priority, true);

            me.ddlStates.setValue(me.entry.Data.State, true);
            me.myHtml.rowMain.infoBox.txtState.html($("<i>").addClass(me.entry.Infos.StatusIcon)).append(" " + me.entry.Infos.Status);

            me.ddlScope.setValue(me.entry.Data.Scope, true);
            me.myHtml.rowMain.infoBox.txtScope.html($("<i>").addClass(me.entry.Infos.ScopeIcon)).append(" " + me.entry.Infos.Scope);
           
            me.myHtml.rowAccounting.txtOrderType.html($("<i>").addClass(me.entry.Infos.OrderTypeIcon)).append(" " + me.entry.Infos.OrderType);
            me.ddlOrderType.setValue(me.entry.Data.OrderTypeID, true);

           
           

            //set 
            var dateStart = $.datepicker.formatDate('dd.mm.yy', $.datepicker.parseDate('dd.mm.yy', me.entry.Data.StartDate));
            me.myHtml.rowMain.infoBox.txtDateStart.val(dateStart);
            me.myHtml.rowMain.infoBox.divDateStart.vcDate({
                defaultDate: dateStart, mode: "Single", align: "center", interval: 1, langID: me.settings.userLangidForCulture,
                callback: function () { me._setDirty(me.myHtml.rowMain.infoBox.divDateStart) }
            });

            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowMain.infoBox.dateCompletion, me.entry.Data.CompletitionDate, true);
            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowUser.userBox.dateExecution, me.entry.Data.ExecutionTime, true);
            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowUser.userBox.dateValidation, me.entry.Data.ValidationTime, true);


            me.myHtml.rowAccounting.txtOrder.val(me.entry.Data.Order);
            me.myHtml.rowAccounting.chkActivities.prop("checked", me.entry.Data.DocuActivities);
            me.myHtml.rowAccounting.chkDeliveryNote.prop("checked", me.entry.Data.DocuDeliveryNote);
            me.myHtml.rowAccounting.chkWorkReport.prop("checked", me.entry.Data.DocuWorkReport);
            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowAccounting.dateAccounting, me.entry.Data.AccountingTime, true);

            objTicketUser._setDefaultUsers(me, false);

            //fill watchlist
            //info: the external watchlist is loaded after new project contacts got received
            var internalWatchlistUser = objTicketUser._getUserID(me, me.entry, me.specific.USER_WATCHLIST_TYPEID);
            me._fillSublist("watchlist", JSON.parse(me.specific.ddlUsers), internalWatchlistUser, !me.specific.readOnlyMode, false);

            //fill external watchlist - only if ticket already exists
            //for new tickets it will be loaded when fetching new project contacts
            if (!bAdd) objTicketUser._fillExtWatchlist(me, me.entry.Blid, !me.specific.readOnlyMode);

            //fill assignments
            objTicketAssignments._setAssignmentType(me);

            //we reset the loading state
            me.initState = false;

            //now we set the user rights
            objTicketUser._setUserRights(me);
            //we toggle between the readonly and edit mode and the edit levels
            me._toggleEdit(!me.specific.readOnlyMode, me.editLevel);

            me._initTextEditor(!me.specific.readOnlyMode);

            me.fnd(".dates").removeClass("dirty");
            //at the end we validate everything for the first time
            me._validate();

            me.divLoading.hide();
            me.divEntry.show();


            //specific settings for print version
            if (me.specific.print) {
                objTicketActivities._fetchActivities(me);

                if(me.specific.activitiesOnly){
                    me._fetchBillingContacts();                    
                }
            }

            return true;
        } catch (e) { me._writeErr(e); return false }

    },

    _fetchBillingContacts: function () {
        /// <summary>
        ///  This function fetches the billing contacts for the current project
        /// </summary>
        var me = this;
        try {
            me.getData({ "typeid": 9, 'TicketID': me.specific.ticketId, LoggerId: me.entry.Blid, fs: {} }, function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                var contact = "";

                for (var i = 0; i < result.rows.length; i++) {

                    var mail = result.rows[i].usermail; // we get the normal user mail

                    if (!mail || mail.trim().length === 0) mail = result.rows[i].email2; // if no user mail (e.g. no platform user), we check the second email field

                    // if no mail address is saved for the contact, we skip the entry
                    if (!mail || mail.trim().length === 0) continue; 

                    if (contact.length > 0) contact += ", ";

                    contact += mail;
                }

                me.myHtml.rowPrintInfo.txtBillingContact.html(contact);
            });

        } catch (e) { me._writeErr(e); return false }

    },

    _fetchProjectInfo: function () {
        /// <summary>
        /// This function fetches the logger description for project info
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            if (!me.entry || !me.entry.Blid || me.entry.Blid <= 0) {
                me.myHtml.rowProjectInfo.txtDescription.html("");
                return true;
            }

            me.myHtml.rowProjectInfo.txtDescription.html(me.getLoadingIcon());

            me.getData({ TypeId: 10, LoggerID: me.entry.Blid }, function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }

                me._fillProjectInfo(result);
                me.myHtml.rowProjectInfo.wrapper.show();
                return true;
            });

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _fillProjectInfo: function (data) {
        /// <summary>
        /// This function fills the project info row
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            var description = "";

            if (data && data.rows && data.rows.length > 0) {
                description = data.rows[0].loggerdescription || "";
            }

            if (description.length === 0) {
                me.myHtml.rowProjectInfo.txtDescription.html("-");
            } else {
                me.myHtml.rowProjectInfo.txtDescription.html(description.replace(/\n/g, "<br/>"));
            }

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },


    _clearForm: function () {
        /// <summary>
        ///  This function cleans up all form items for an empty initial state
        /// </summary>
        var me = this;
        try {
            if (me.error) {
                return false;
            }
            //we set a default assignment type
            me.assignmentType = me.specific.ASSIGNMENT_PROJECT_TYPEID;
            objTicketAssignments._toggleAssignmentEditButtons(me, me.specific.ASSIGNMENT_PROJECT_TYPEID);

            //clean up all entries
            me.fnd("#div-id,.formItem div.value.readonly").html("");
            me.fnd("#txt-name,#txt-order,#area-description,.formItem input.value.readonly").val("");

            me.ddlOwner.setValue(-1, true);
            me.ddlTasks.setValue(-1, true);
            me.ddlScope.setValue(-1, true);
            me.ddlPriorities.setValue(5, true);
            me.ddlStates.setValue(-1, true);
            me.ddlOrderType.setValue(-1, true);

            me.myHtml.rowAccounting.chkActivities.prop("checked", false);
            me.myHtml.rowAccounting.chkDeliveryNote.prop("checked", false);
            me.myHtml.rowAccounting.chkWorkReport.prop("checked", false);



            if (me.myHtml.rowMain.infoBox.divDateStart.hasClass("vc-date")) { me.myHtml.rowMain.infoBox.divDateStart.vcDate("destroy"); }
            if (me.myHtml.rowMain.infoBox.dateCompletion.divDate.hasClass("vc-date")) { me.myHtml.rowMain.infoBox.dateCompletion.divDate.vcDate("destroy"); }

            me.ddlLogger.setValue(-1, true);
            if (me.ddlUnit !== null) { me.ddlUnit.destroy(); };
            if (me.ddlHW !== null) { me.ddlHW.destroy(); };


            me.ddlExecutor.setValue(-1, true);
            me.ddlValidator.setValue(-1, true);
            me.ddlAccounter.setValue(-1, true);
            if (me.myHtml.rowUser.userBox.dateExecution.divDate.hasClass("vc-date")) { me.myHtml.rowUser.userBox.dateExecution.divDate.vcDate("destroy"); }
            if (me.myHtml.rowUser.userBox.dateValidation.divDate.hasClass("vc-date")) { me.myHtml.rowUser.userBox.dateValidation.divDate.vcDate("destroy"); }
            if (me.myHtml.rowAccounting.dateAccounting.divDate.hasClass("vc-date")) { me.myHtml.rowAccounting.dateAccounting.divDate.vcDate("destroy"); }

            //clean up date pickers
            me.fnd(".type-date").removeClass("removed-date-picker");
            me.fnd(".dates .value.edit").removeClass("vc-date");
            me.fnd(".dates .value.readonly").val("");

            me.fnd(".sublist ul").html("");
            me.fnd(".formItem").removeClass("dirty");

            return true;
        } catch (e) { me._writeErr(e); return false; }

    },
    _initSelectize: function (obj, data, setDirty) {
        /// <summary>
        ///  This function generates a dropdown list based on selectize.js.
        /// </summary>
        var me = this;

        try {
            if (me.error) { return false; }

            var item = obj.selectize({
                create: false,
                maxItems: 1,
                valueField: 'Id',
                labelField: 'Name',
                searchField: 'Name',
                options: data,
                dropdownParent: 'body',
                render: {
                    option: function (item, escape) {
                        var sTmp = "<div class='option '>";
                        if (item.Icon.length > 0) { sTmp += "<i class='fa " + item.Icon + "'></i> "; }
                        sTmp += escape(item.Name) + "</div>";
                        return sTmp;
                    }
                },
                onChange: function () {
                    if (typeof (setDirty) !== "undefined") {
                        if (setDirty) { me._setDirty(obj); }
                    }
                }
            });
            return item[0].selectize;
        } catch (e) { me._writeErr(e); return false }

    },
    _initTextEditor: function (bEdit) {
        /// <summary>
        ///  This function generates the cleditor instance and writes every text change to a variable
        /// </summary>
        var me = this;
        var h, w;
        try {
            if (me.error) { return false; }

            me.descriptionText = typeof (me.descriptionText) !== "undefined" ? me.entry.Data.Description : "";

            me.myHtml.rowMain.infoBox.txtDescription.val(me.descriptionText);
            me.myHtml.rowMain.infoBox.divDescription.html(me.descriptionText);

            w = parseInt(me.myHtml.rowMain.infoBox.wrapper.width()) - 30;
            h = parseInt(me.myHtml.rowMain.infoBox.wrapper.height() - me.myHtml.rowMain.infoBox.main.height()) - 35;

            me.areaDescription = me.myHtml.rowMain.infoBox.txtDescription.cleditor({
                'height': h, 'width': w, updateTextArea: function (e) {

                    if (e.indexOf("mso-ansi-language") > -1 || e.indexOf("<o:") > -1 || e.indexOf("<w:") > -1) {
                        me.myHtml.rowMain.infoBox.txtDescription.val(me.descriptionText).blur().focus();
                        me.openHtmlCleanupDialog();
                        return true;

                    } else {

                        let txt = e.replace(/\n/g, "<br />")

                        me._setDirty(me.myHtml.rowMain.infoBox.txtDescription);

                        me.descriptionText = txt;
                        me.myHtml.rowMain.infoBox.txtDescription.val(txt).blur();
                        me.myHtml.rowMain.infoBox.divDescription.html(txt);
                    }
                },
                controls: 'bold italic underline |  removeformat | bullets numbering '
            })[0];

            me.areaDescription.refresh();
            me.myHtml.rowMain.infoBox.divDescription.height(h);

            //hide the editor if we are in the readonly view
            if (bEdit) {
                me.fnd(".cleditorMain").show();
            } else {
                me.fnd(".cleditorMain").hide();
            }

            return true;
        } catch (e) { me._writeErr(e); return false }

    },
    _toggleEdit: function (edit, level) {
        /// <summary>
        ///  This function switches between the readonly and the edit mode
        /// </summary>
        var me = this;

        try {

            if (me.error) { return false; }

            if (edit) {

                me.myHtml.topMenu.state.show();
                me.fnd("#div-entry .cleditorMain").show();

                if (level === 1) { //start process, new entry

                    me.myHtml.rowMain.infoBox.txtName.attr("readonly", false);
                    me.myHtml.rowMain.assignmentBox.divEdit.show();
                    me.myHtml.rowMain.infoBox.dateCompletion.divDate.show();
                    me.myHtml.rowUser.userBox.divValidator.show();
                    me.myHtml.rowUser.userBox.divDateValidationBox.show();
                    me.myHtml.rowAccounting.divAccounter.show();
                    me.myHtml.rowAccounting.divDateAccountingBox.show();
                    me._toggleSublist("watchlist", true);

                }

                objTicketAssignments._showAssignments(me, me.assignmentsEditable);

                me.fnd("#div-entry .formItem").removeClass("readonly");
                me.fnd("#div-entry .readonly").hide();
                me.fnd("#div-entry .edit").show();
                me.fnd("#div-entry .dates").addClass("type-date").removeClass("type-text");



                if (me.specific.simpleEditMode) { 

                    //when adding a new ticket - we have no texts available
                    if (me.specific.ticketId == -1) {
                        me.myHtml.rowMain.infoBox.txtTasks.html(me.ddlTasks.getItem(me.ddlTasks.getValue())[0].innerHTML);
                        me.myHtml.rowMain.infoBox.txtPriority.html(me.ddlPriorities.getItem(me.ddlPriorities.getValue())[0].innerHTML);
                        me.myHtml.rowMain.infoBox.txtScope.html(me.ddlScope.getItem(me.ddlScope.getValue())[0].innerHTML);
                        me.myHtml.rowMain.infoBox.txtState.html(me.ddlStates.getItem(me.ddlStates.getValue())[0].innerHTML);
                    }
                   
                    //select_option.getItem(select_option.getValue())[0].innerHTML
                    me.fnd("#div-entry .no-simple-edit .formItem").addClass("readonly");
                    me.fnd("#div-entry .no-simple-edit.formItem").addClass("readonly");
                    me.fnd("#div-entry .no-simple-edit .readonly").show();
                    me.fnd("#div-entry .no-simple-edit .edit").hide();
                    me.fnd("#div-entry .no-simple-edit .dates").removeClass("type-date").addClass("type-text");
                    if (me.ddlValidator.getValue().length === 0) {
                        me.myHtml.rowUser.userBox.divValidator.hide();
                        me.myHtml.rowUser.userBox.divDateValidationBox.hide();
                    } 
                 
                    me.myHtml.rowAccounting.txtOrder.attr("readonly", true);
                    me.myHtml.rowAccounting.chkActivities.attr("readonly", true).attr("disabled", true);
                    me.myHtml.rowAccounting.chkDeliveryNote.attr("readonly", true).attr("disabled", true);
                    me.myHtml.rowAccounting.chkWorkReport.attr("readonly", true).attr("disabled", true);
                    me._toggleSublist("watchlist", false);
                }
               


            } else {

                me.dirty = false;
                me.fnd(".dirty").removeClass("dirty");
                me.fnd(".error").removeClass("error");

                me.myHtml.topMenu.state.removeClass("clear").addClass("clear");
                me.myHtml.topMenu.btnSave.button("disable");
                me.myHtml.topMenu.btnSaveClose.button("disable");
                me.myHtml.topMenu.state.hide();
                me.fnd(".formItem").addClass("readonly");
                me.fnd(".readonly").show();
                me.fnd(".edit").hide();
                me.fnd(".dates").removeClass("type-date").addClass("type-text");
                me.fnd(".type-text input").attr("readonly", true);

                me.myHtml.rowMain.infoBox.txtName.attr("readonly", true);

                me.myHtml.rowAccounting.txtOrder.attr("readonly", true);
                me.myHtml.rowAccounting.chkActivities.attr("readonly", true).attr("disabled", true);
                me.myHtml.rowAccounting.chkDeliveryNote.attr("readonly", true).attr("disabled", true);
                me.myHtml.rowAccounting.chkWorkReport.attr("readonly", true).attr("disabled", true);

                me.fnd(".cleditorMain").hide();

                if (me.ddlValidator.getValue().length === 0) {
                    me.myHtml.rowUser.userBox.divValidator.hide();
                    me.myHtml.rowUser.userBox.divDateValidationBox.hide();
                } else {
                    me.myHtml.rowUser.userBox.divValidator.show();
                    me.myHtml.rowUser.userBox.divDateValidationBox.show();
                }

                if (me.ddlAccounter.getValue().length === 0) {
                    me.myHtml.rowAccounting.divAccounter.hide();
                    me.myHtml.rowAccounting.divDateAccountingBox.hide();
                } else {
                    me.myHtml.rowAccounting.divAccounter.show();
                    me.myHtml.rowAccounting.divDateAccountingBox.show();
                }

                me.myHtml.rowMain.assignmentBox.divEdit.hide();
                objTicketAssignments._setAssignmentType(me);



                objTicketAssignments._toggleAssignmentEditButtons(me, me.assignmentType);
                objTicketAssignments._showAssignments(me, false);
                me._toggleSublist("watchlist", false);

            }

            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowMain.infoBox.dateCompletion, me.entry.Data.CompletitionDate, edit);
            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowUser.userBox.dateExecution, me.entry.Data.ExecutionTime, edit);
            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowUser.userBox.dateValidation, me.entry.Data.ValidationTime, edit);
            objTicketDatePicker._setDatePickerState(me, me.myHtml.rowAccounting.dateAccounting, me.entry.Data.AccountingTime, edit);


            return true;
        } catch (e) { me._writeErr(e); return false; }

    },
    _fillSublist: function (id, data, selected, showAll, addDescription) {
        /// <summary>
        ///  This function generates a vc-list for all data entries incl. a selection checkbox
        /// </summary>
        var me = this;
        var item;
        var ul;
        var i, j;
        var el, el1;
        var chb;
        var bSelected = false;
        var bFound = false;
        try {
           
            if (me.error) { return false; }
         
            me.fnd("#div-" + id).html(me.getLoadingIcon());

            ul = $("<ul>").attr("id", "lst-" + id).addClass("vc-list-selection");


            for (i = 0; i < data.length; i++) {
                bSelected = false;
                //find selected entries
                for (j = 0; j < selected.length; j++) {
                    if (data[i].Id === selected[j]) { bSelected = true; }
                }
                if (bSelected) {


                    


                    bFound = true;
                    item = $("<li>").addClass("vc-list-item").data("id", data[i].Id);
                    el = $("<div>").addClass("vc-list-col-element");
                    chb = $("<input>").addClass("chb-" + id).attr("type", "checkbox").data("id", data[i].Id)
                        .attr("id", "chb-" + id + "-" + data[i].Id);

                    item.addClass("selected");
                    chb.prop("checked", true);
                    let name = data[i].Name;
                    if (addDescription) {
                        name = "<b>" + name + "</b>";
                        name += "<hr/>" + data[i].Description;
                    }

                    //el1 = $("<div>").addClass("vc-list-col-element");
                    el.append(chb, "<span>" + name + "</span>");
                    if (id === "signals") {
                        el.append(" <i data-id='" + data[i].Id + "' class='fa-regular fa-lg fa-info-circle color-font-secondary '></i>");
                    }

                    ul.append(item.append(el));
                }
            }
            for (i = 0; i < data.length; i++) {
                bSelected = false;
                //find selected entries
                for (j = 0; j < selected.length; j++) {
                    if (data[i].Id === selected[j]) { bSelected = true; }
                }
                if (!bSelected) {

                    item = $("<li>").addClass("vc-list-item").data("id", data[i].Id);
                    el = $("<div>").addClass("vc-list-col-element");
                    chb = $("<input>").addClass("chb-" + id).attr("type", "checkbox").data("id", data[i].Id)
                        .attr("id", "chb-" + id + "-" + data[i].Id);
                    el.append(chb, "<span>" + data[i].Name + "</span>");
                    if (id === "signals") {
                        el.append(" <i data-id='" + data[i].Id + "' class='fa-regular fa-lg fa-info-circle color-font-secondary '></i>");
                    }

                    ul.append(item.append(el));
                }
            }

            me.fnd("#div-" + id).html(ul);
           
            me._toggleSublist(id, showAll);


            if (me.specific.print) {
             
                if (!bFound) { me.fnd("#div-" + id).parents(".formFieldset").hide(); }
            }

            return true;
        } catch (e) { console.info(e); me._writeErr(e); return false }

    },
    _toggleSublist: function (id, showAll) {
        /// <summary>
        ///  This function shows/hides all sublist items incl. the selection checkbox
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            me.fnd("#lst-" + id + " li").removeClass("alt");
            if (showAll) {
                me.fnd("#lst-" + id + " li").show();
                me.fnd("#lst-" + id + " li input[type=checkbox]").attr("readonly", false).show();
                me.fnd("#lst-" + id + " li:even").addClass("alt");

            } else {
                me.fnd("#lst-" + id + " li").hide();
                me.fnd("#lst-" + id + " li input[type=checkbox]").hide();
                me.fnd("#lst-" + id + " li.selected").show();
                me.fnd("#lst-" + id + " li.selected:even").addClass("alt");
            }

            return true;
        } catch (e) { me._writeErr(e); return false }

    },
    _validate: function () {
        /// <summary>
        ///  This function validates all neccessary values
        /// </summary>
        return objTicketValidation._validate(this);
    },
    _setDirty: function (obj) {
        /// <summary>
        ///  This function sets the dirty state for an object
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            if (me.initState === false) {
                obj.parent(".formItem").removeClass("dirty").addClass("dirty");
                obj.parents(".formItem").removeClass("dirty").addClass("dirty");
                me.dirty = true;
                me._validate();
            }
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },
    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            if (me.specific.readOnlyMode || !me.specific.hasRootMembership) {
                me.myHtml.topMenu.btnDelete.hide();
            }

            me.myHtml.rowMain.wrapper.height(600);

            me.myHtml.rowMain.assignmentBox.wrapper.height(parseInt(me.myHtml.rowMain.wrapper.height()) - 21);
            me.myHtml.rowMain.infoBox.wrapper.height(parseInt(me.myHtml.rowMain.wrapper.height()) - 21);

            //set height for assignment sublist
            me.myHtml.rowMain.assignmentBox.signalList.height(parseInt(me.myHtml.rowMain.assignmentBox.wrapper.height() - me.myHtml.rowMain.assignmentBox.divSignalFilter.height()) - 196);

            var subBoxHeight = parseInt(me._getVisualHeight() - me.myHtml.topMenu.wrapper.height()) - 67;

            me.myHtml.rowAccounting.wrapper.height(subBoxHeight);

            if (me.specific.print) {
                me.myHtml.rowActivities.wrapper.css("height", "auto");
            } else {
                me.myHtml.rowActivities.wrapper.height(subBoxHeight);
            }

            me.myHtml.rowWatchlist.wrapper.height(subBoxHeight);
            me.myHtml.rowWatchlist.divWatchlist.height(subBoxHeight - 20);

            me.myHtml.rowExtWatchlist.wrapper.height(subBoxHeight);
            me.myHtml.rowExtWatchlist.divWatchlist.height(subBoxHeight - 20);

            me.myHtml.rowEmailHistory.wrapper.height(subBoxHeight);
            me.myHtml.rowEmailHistory.divEmailList.height(subBoxHeight - 20);

            me.myHtml.rowProjectInfo.wrapper.height(subBoxHeight);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _openEmailDialog: function (no, intern, all) {
        /// <summary>
        /// This function opens a dialog popup for common validation usage.
        /// yes, no, cancel are functions which get executed 
        /// pos can add specific position settings eg: of: target! - fixes position to target
        /// </summary>
        var me = this;
        try {

            var caption = me.specific.resources.notifyUsers + "";
            var pos = { at: 'center center-30%', of: window };

            var d = $('<p>' + caption + '</p>').dialog({
                position: pos,
                title: me.resources.dialogTitle, modal: true,
                buttons: {
                    "No": function () { no(); d.dialog('close'); return true; },
                    "Internal": function () { intern(); d.dialog('close'); return false; },
                    "All": function () { all(); d.dialog('close'); return false; }
                },
                dialogClass: 'saveDialog'
            });

            //if (typeof (canc) === "undefined") { $('.saveDialog .ui-button-text:contains(CANCEL)').hide(); }

            // ReSharper disable InvalidValue
            $('.saveDialog .ui-button-text:contains(NO)').text(me.resources.no);
            $('.saveDialog .ui-button-text:contains(Internal)').text(me.specific.resources.internalOnly);
            $('.saveDialog .ui-button-text:contains(ALL)').text(me.specific.resources.all);
            // ReSharper restore InvalidValue
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _askForEmailSendingBeforeSave: function () {
        /// <summary>
        /// This function opens the email dialog asking if an email should get sent<br/>
        /// </summary>
        var me = this;
        try {

            if (me.error) { return false; }
            if (!me.dirty) { me.showMessage(me.resources.err_saveData, true); return false; }

            //we always send emails to all contacts
            if (me.specific.simpleEditMode) {
                me.sendEmailType = 0;
                me._save(true); 
            } else {


                me.divEntry.css("opacity", 0.2);
                me._openEmailDialog(function () {
                    me.sendEmailType = 0;
                    me._save(true);
                    return true;
                }, function () {
                    me.sendEmailType = 1;
                    me._save(true); return true;
                }, function () {
                    me.sendEmailType = 2;
                    me._save(true); return true;
                });


            }

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },
    _save: function (closeAfterSave) {
        /// <summary>
        /// Saves the data.<br/>
        /// </summary>
        var me = this;
        var i;
        var bFound;
        var id;
        try {
            if (me.error) { return false; }

            if (!me.dirty) { me.showMessage(me.resources.err_saveData, true); return false; }

            closeAfterSave = (closeAfterSave !== false);

            me.entry.Blid = parseInt(me.ddlLogger.getValue());


            me.entry.Data.Name = me.myHtml.rowMain.infoBox.txtName.val();
            me.entry.Data.Description = me.descriptionText;
            me.entry.Data.Notify = false;

            me.entry.Data.TaskID = parseInt(me.ddlTasks.getValue());
            me.entry.Data.Priority = parseInt(me.ddlPriorities.getValue());
            me.entry.Data.Scope = parseInt(me.ddlScope.getValue());
            me.entry.Data.State = parseInt(me.ddlStates.getValue());

            me.entry.Data.StartDate = me.myHtml.rowMain.infoBox.divDateStart.vcDate("getDate").from;
            me.entry.Data.CompletitionDate = me.myHtml.rowMain.infoBox.dateCompletion.divDate.hasClass("vc-date") ? me.myHtml.rowMain.infoBox.dateCompletion.divDate.vcDate("getDate").from : "";
            me.entry.Data.ExecutionTime = me.myHtml.rowUser.userBox.dateExecution.divDate.hasClass("vc-date") ? me.myHtml.rowUser.userBox.dateExecution.divDate.vcDate("getDate").from : "";
            me.entry.Data.ValidationTime = me.myHtml.rowUser.userBox.dateValidation.divDate.hasClass("vc-date") ? me.myHtml.rowUser.userBox.dateValidation.divDate.vcDate("getDate").from : "";
            me.entry.Data.AccountingTime = me.myHtml.rowAccounting.dateAccounting.divDate.hasClass("vc-date") ? me.myHtml.rowAccounting.dateAccounting.divDate.vcDate("getDate").from : "";


            me.entry.Data.Order = me.myHtml.rowAccounting.txtOrder.val();
            me.entry.Data.OrderTypeID = parseInt(me.ddlOrderType.getValue());

            me.entry.Data.DocuActivities = me.myHtml.rowAccounting.chkActivities.prop("checked");
            me.entry.Data.DocuDeliveryNote = me.myHtml.rowAccounting.chkDeliveryNote.prop("checked");
            me.entry.Data.DocuWorkReport = me.myHtml.rowAccounting.chkWorkReport.prop("checked");



            //add different user types
            var user = [];
            user.push({ TypeId: me.specific.USER_OWNER_TYPEID, Uid: parseInt(me.ddlOwner.getValue()) });
            if (me.ddlExecutor.getValue().length > 0) {
                user.push({ TypeId: me.specific.USER_EXECUTOR_TYPEID, Uid: parseInt(me.ddlExecutor.getValue()) });
            }
            //TODO: better validation of dropdowns
            if (me.ddlValidator.getValue().length > 0) {
                user.push({ TypeId: me.specific.USER_VALIDATOR_TYPEID, Uid: parseInt(me.ddlValidator.getValue()) });
            }
            if (me.ddlAccounter.getValue().length > 0) {
                user.push({ TypeId: me.specific.USER_ACCOUNTING_TYPEID, Uid: parseInt(me.ddlAccounter.getValue()) });
            }



            //we add the the watchlist users (only if they do not already exist)
            me.fnd("#div-watchlist .chb-watchlist:checked").each(function () {
                id = parseInt($(this).data("id"));
                bFound = false;
                for (i = 0; i < user.length; i++) { if (user[i].Uid === id) { bFound = true; } }
                if (!bFound) { user.push({ TypeId: me.specific.USER_WATCHLIST_TYPEID, Uid: id }); }
            });

            me.fnd("#div-ext-watchlist .chb-ext-watchlist:checked").each(function () {
                id = parseInt($(this).data("id"));
                bFound = false;
                for (i = 0; i < user.length; i++) { if (user[i].Uid === id) { bFound = true; } }
                if (!bFound) { user.push({ TypeId: me.specific.USER_EXTERNALEMAIL_TYPEID, Uid: id }); }
            });

            me.entry.Users.Users = user;


            var assignmentTypes = {}
            var assign = [];
            bFound = false;
            switch (me.assignmentType) {
                case me.specific.ASSIGNMENT_UNIT_TYPEID:
                    assignmentTypes.Bluid = parseInt(me.ddlUnit.getValue());
                    assignmentTypes.Blhid = me.ddlHW.getValue().length > 0 ? parseInt(me.ddlHW.getValue()) : -1;
                    bFound = true;
                    break;
                case me.specific.ASSIGNMENT_SIGNAL_TYPEID:
                    me.fnd("#div-signals .chb-signals:checked").each(function () {
                        assign.push({ TypeId: me.specific.ASSIGNMENT_SIGNAL_TYPEID, AssId: parseInt($(this).data("id")) });
                        bFound = true;
                    });
                    break;
            }
           
            me.entry.Assignments.Assignments = assign;
            me.entry.Assignments.AssignmentTypes = assignmentTypes;
            me.entry.ExternalEmail = true;
           
            me.myHtml.topMenu.btnSave.button("disable");
            me.myHtml.topMenu.btnSaveClose.button("disable");

            if (closeAfterSave === true) {
                me.divLoading.html(me.specific.resources.savingChanges).addClass("info").css("margin-top", 20).css("text-align", "center").show();
                me.divEntry.hide();
            }

            me.updateData({ TypeId: 1, Entry: me.entry, SendEmailType: me.sendEmailType }, function (result) {

                // re-enable BOTH
                me.myHtml.topMenu.btnSave.button("enable");
                me.myHtml.topMenu.btnSaveClose.button("enable");

                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);

                    me.divLoading.hide().removeClass("info");
                    me.divEntry.show().css("opacity", 1);

                    return false;
                }

                // success
                if (closeAfterSave) {
                    me._close(true);
                    return true;
                }

                // stay open (Save only)
                me.divLoading.hide().removeClass("info");
                me.divEntry.show().css("opacity", 1);

                me.dirty = false;
                me.fnd("#div-entry .dirty").removeClass("dirty");


                // show "saved" info briefly
                if (me.myHtml.topMenu.saved) {
                    me.myHtml.topMenu.saved.stop(true, true).show();
                    window.setTimeout(function () {
                        try { me.myHtml.topMenu.saved.fadeOut(400); } catch (e) {
                            me.myHtml.topMenu.saved.hide();                            
                        }
                    }, 1200);
                }

                me._validate(); // disables buttons because no dirty items

                return true;
            });


            return true;
        } catch (e) { me._writeErr(e); return false; }
    },
    _askBeforeDelete: function () {
        /// <summary>
        ///  This function opens dialog before deleting
        /// </summary>
        var me = this;

        try {
            if (me.error) { return false }
          
            me.divEntry.css("opacity", 0.2);
            me.openAskDialog(me.specific.resources.deleteEntry + "?",
                { my: 'center', at: 'center', of: window },
                function () { me._delete(); },
                function () {
                    me.divEntry.css("opacity", 1);
                    return true;
                });

            return true;
        } catch (e) { me._writeErr(e); return false }

    },
    _delete: function () {
        /// <summary>
        /// Deletes the current entry and reloads the list.<br/>
        /// The delete dialog is done before!
        /// </summary>
        var me = this;

        try {
            if (me.error) { return false; }
            if (me.specific.readOnlyMode || !me.specific.hasRootMembership) return false;

            me.updateData({ TypeId: 2, Entry: me.entry }, function (result) {

                if (result === null) {
                    me.showMessage(me.resources.err_saveData, true); return false;
                }
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true); return false;
                }
                me._close(true);
                return true;
            });
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },
    _askDismissChanges: function () {
        /// <summary>
        ///  This function cleans up all form items for an empty initial state
        /// </summary>
        var me = this;
        try {
            if (me.error) {return false;}
            if (me.dirty) {

                me.divEntry.css("opacity", 0.2);
                if (me.myHtml.topMenu.state.hasClass("error")) {
                    me.openAskDialog(me.specific.resources.dismissChanges,
                        { my: 'center', at: 'center', of: window },
                        function () {
                            //close without saving
                            $("body").trigger({ type: "Trigger-singleTicket-closed" });
                            return true;
                        },
                        function () {
                            me.divEntry.css("opacity", 1);
                            return false;
                        });
                } else {
                    me.openAskDialog(me.specific.resources.shouldChangesGetApplied,
                        { my: 'center', at: 'center', of: window },
                        function () { me._askForEmailSendingBeforeSave(); return true; },
                        function () {
                            //close without saving
                            $("body").trigger({ type: "Trigger-singleTicket-closed" });
                            return true;
                        },
                        function () {
                            me.divEntry.css("opacity", 1);
                            return false;
                        });
                }
            } else {
              
                me._close();
             
            }
            return true;
        } catch (e) { me._writeErr(e);  return false; }

    },
    _openPrint: function () {
        /// <summary>
        ///  This function opens a new browser tab with the printable version
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            window.open(window.location.origin + '/' + window.location.pathname.split('/')[1] + '/html/share/Ticket.aspx?id=' + me.entry.Id + '&blid=' + me.entry.Blid + "&lang=" + me.settings.userLangIDForCulture + "&acc=" + me.specific.accountingMode, '_blank');

            return true;
        } catch (e) { me._writeErr(e); return false; }

    },

    _openPrintActivities: function () {
        /// <summary>
        ///  This function opens a new browser tab with the printable version of the filtered activities
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            var order = (me.activitiesOrderFilter || "").toString().trim();

            // we get all selected ids from session storage
            var selectedIds = [];
            try {
                var ticketId = me.entry && me.entry.Id ? me.entry.Id : (me.specific && me.specific.ticketId);
                if (ticketId && window.localStorage) {
                    var keySel = "ticketSelectedActivities_" + ticketId;
                    var raw = localStorage.getItem(keySel);
                    if (raw) selectedIds = JSON.parse(raw) || [];
                }
            } catch (e) { selectedIds = []; }

            // if no selected ids and no order number filtering, we do nothing
            if (!order.length && (!selectedIds || !selectedIds.length)) return false;

            window.open(window.location.origin + '/' + window.location.pathname.split('/')[1] + '/html/share/Ticket.aspx?id=' + me.entry.Id + '&blid=' + me.entry.Blid + "&lang=" + me.settings.userLangIDForCulture + "&acc=" + me.specific.accountingMode + '&activitiesOnly=true' + '&filterorder=' + encodeURIComponent(order), '_blank');

            return true;
        } catch (e) { me._writeErr(e); return false; }

    },



    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function calls hides the content on error state.
        /// </summary>
        var me = this;
        try {
            if (bError) {
                 me.divEntry.hide();
            }
            return true;
        } catch (e) { me._writeErr(e); return false }
    },
    _close: function (bHide) {
        /// <summary>
        ///  This function generates a vc-list based on the given entries. 
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            _VCMQ.produce(me.visual, me.vcgid, 'TICKETS_CHANGED', "");
            $("body").trigger({ type: "Trigger-singleTicket-closed" });
           

            return true;
        } catch (e) { me._writeErr(e); return false }

    },

    ////TODO: remove writeError
    //_writeErr: function (ex) {
    //    var me = this;
    //    //console.error(ex);

    //    me.showMessage(me.resources.err_code, true);
    //    //this._writeErr(ex);
    //    },

});
